// Customer-side service packages, booking with a package or membership, and the copy shared
// with the store side. Deep-merged into the main bundle in i18n.js.
// A membership or package use is now one visit, however many of its services it has, so the
// membership wording below replaces "uses" with "visits".

export const servicePackageTranslationsEn = {
  membershipPlansManagement: {
    fields: {
      allowanceQuantity: 'Visits per month',
    },
  },
  managementAppointments: {
    book: {
      membershipOrPackage: 'Membership or package',
      membershipOrPackageHelp: 'Choose a membership or package only when this visit should use it. A package or membership covers the appointment only when all of its services are booked.',
      noEntitlementRedemption: 'Pay normally',
      packageTag_one: 'Package · {{count}} left',
      packageTag_other: 'Package · {{count}} left',
      packageExpiredTag: 'Expired for this date',
      packageInUseTag: 'In use',
      packageServicesLocked: 'Package services are selected and cannot be removed. You can still add extra services.',
    },
  },
  customer: {
    navigation: {
      packages: 'Packages',
    },
    memberships: {
      entitlement: {
        allowance: '{{count}} visits per month',
      },
      usage: {
        remaining: '{{remaining}} of {{total}} visits left this period',
      },
    },
    packages: {
      title: 'Packages',
      subtitle: 'Pay once and book your appointments when it suits you.',
      browseOnly: 'Packages are sold at the store. Ask the team next time you visit.',
      inStoreOnlyMessage: 'Available at the store.',
      card: {
        unnamed: 'Package',
        owned: 'Yours',
        quantity_one: '{{count}} appointment',
        quantity_other: '{{count}} appointments',
        expiresInMonths_one: 'Valid for {{count}} month',
        expiresInMonths_other: 'Valid for {{count}} months',
        noExpiry: 'No expiry date',
        includes: 'Includes: {{services}}',
      },
      usage: {
        remaining: '{{remaining}} of {{total}} left',
        validUntil: 'Valid until {{date}}',
        noExpiry: 'No expiry date',
      },
      actions: {
        buy: 'Buy package',
        bookWithPackage: 'Book with package',
        unavailable: 'Not available online',
      },
      checkout: {
        processing: 'We are confirming your payment. Your package appears here as soon as it is done.',
        success: 'Payment received. Your package is ready to use.',
      },
      expiryWarning: {
        title: 'This package expires',
        message_one: 'This package is valid for {{count}} month after you buy it, until {{date}}. Appointments not used by then are lost and cannot be refunded.',
        message_other: 'This package is valid for {{count}} months after you buy it, until {{date}}. Appointments not used by then are lost and cannot be refunded.',
        confirm: 'I understand, continue',
      },
      empty: {
        title: 'No packages yet',
        subtitle: 'This store has no packages on sale right now.',
      },
      error: {
        loading: 'Could not load the packages. Please try again.',
        alreadyActive: 'You already have this package. Use it up before buying it again.',
        unavailable: 'This package is no longer on sale.',
        onlinePaymentsDisabled: 'This store takes your payments at the store. Ask the team to buy this package.',
      },
      profile: {
        title: 'My packages',
      },
    },
    appointments: {
      booking: {
        yourPackages: 'Your packages',
        discoverPackagesPrompt: 'Coming often?',
        seePackages: 'See our packages',
        packageExtrasHint: 'Package services stay selected. You can add extra paid services.',
        payWithPackage: 'Use package: {{package}} ({{remaining}} left)',
        packageSuccess: 'Appointment booked with your package!',
        entitlementErrors: {
          membershipRequiresAllServices: 'This membership only covers a visit that includes all of its services. Add them, or pay another way.',
          membershipExceeded: 'This membership has no visits left for this period. Choose another way to pay.',
          packageRequiresAllServices: 'This package only covers a visit that includes all of its services. Add them, or pay another way.',
          packageExhausted: 'This package has no appointments left. Choose another way to pay.',
          packageExpired: 'This package expires before the appointment date. Choose an earlier date or pay another way.',
          packageProfessional: 'This package can only be booked with some professionals. Choose one of them.',
          packageNotUsable: 'This package cannot be used right now. Choose another way to pay.',
          conflict: 'An appointment can use only one membership or one package.',
        },
      },
      myAppointments: {
        coveredByPackage: 'Covered by package',
        packageNote: 'Package: {{package}}',
      },
    },
  },
};

export const servicePackageTranslationsPt = {
  membershipPlansManagement: {
    fields: {
      allowanceQuantity: 'Visitas por mês',
    },
  },
  managementAppointments: {
    book: {
      membershipOrPackage: 'Assinatura ou pacote',
      membershipOrPackageHelp: 'Escolha uma assinatura ou pacote apenas quando esta visita o deve usar. Um pacote ou assinatura só cobre o agendamento quando todos os seus serviços estão marcados.',
      noEntitlementRedemption: 'Pagar normalmente',
      packageTag_one: 'Pacote · {{count}} restante',
      packageTag_other: 'Pacote · {{count}} restantes',
      packageExpiredTag: 'Expirado nesta data',
      packageInUseTag: 'Em uso',
      packageServicesLocked: 'Os serviços do pacote estão selecionados e não podem ser removidos. Pode adicionar serviços extra.',
    },
  },
  customer: {
    navigation: {
      packages: 'Pacotes',
    },
    memberships: {
      entitlement: {
        allowance: '{{count}} visitas por mês',
      },
      usage: {
        remaining: '{{remaining}} de {{total}} visitas restantes neste período',
      },
    },
    packages: {
      title: 'Pacotes',
      subtitle: 'Pague uma vez e marque os seus agendamentos quando lhe der jeito.',
      browseOnly: 'Os pacotes são vendidos na loja. Peça à equipa na próxima visita.',
      inStoreOnlyMessage: 'Disponível na loja.',
      card: {
        unnamed: 'Pacote',
        owned: 'Seu',
        quantity_one: '{{count}} agendamento',
        quantity_other: '{{count}} agendamentos',
        expiresInMonths_one: 'Válido durante {{count}} mês',
        expiresInMonths_other: 'Válido durante {{count}} meses',
        noExpiry: 'Sem data de validade',
        includes: 'Inclui: {{services}}',
      },
      usage: {
        remaining: '{{remaining}} de {{total}} restantes',
        validUntil: 'Válido até {{date}}',
        noExpiry: 'Sem data de validade',
      },
      actions: {
        buy: 'Comprar pacote',
        bookWithPackage: 'Marcar com o pacote',
        unavailable: 'Indisponível online',
      },
      checkout: {
        processing: 'Estamos a confirmar o seu pagamento. O pacote aparece aqui assim que estiver concluído.',
        success: 'Pagamento recebido. O seu pacote está pronto a usar.',
      },
      expiryWarning: {
        title: 'Este pacote tem validade',
        message_one: 'Este pacote é válido durante {{count}} mês após a compra, até {{date}}. Os agendamentos não usados até lá perdem-se e não são reembolsados.',
        message_other: 'Este pacote é válido durante {{count}} meses após a compra, até {{date}}. Os agendamentos não usados até lá perdem-se e não são reembolsados.',
        confirm: 'Compreendo, continuar',
      },
      empty: {
        title: 'Ainda sem pacotes',
        subtitle: 'Esta loja não tem pacotes à venda neste momento.',
      },
      error: {
        loading: 'Não foi possível carregar os pacotes. Tente novamente.',
        alreadyActive: 'Já tem este pacote. Use-o até ao fim antes de o comprar novamente.',
        unavailable: 'Este pacote já não está à venda.',
        onlinePaymentsDisabled: 'Esta loja recebe os seus pagamentos na loja. Peça à equipa para comprar este pacote.',
      },
      profile: {
        title: 'Os meus pacotes',
      },
    },
    appointments: {
      booking: {
        yourPackages: 'Os seus pacotes',
        discoverPackagesPrompt: 'Vem com frequência?',
        seePackages: 'Veja os nossos pacotes',
        packageExtrasHint: 'Os serviços do pacote permanecem selecionados. Pode adicionar serviços extra pagos.',
        payWithPackage: 'Usar pacote: {{package}} ({{remaining}} restantes)',
        packageSuccess: 'Agendamento marcado com o seu pacote!',
        entitlementErrors: {
          membershipRequiresAllServices: 'Esta assinatura só cobre uma visita que inclua todos os seus serviços. Adicione-os ou pague de outra forma.',
          membershipExceeded: 'Esta assinatura não tem visitas restantes neste período. Escolha outra forma de pagamento.',
          packageRequiresAllServices: 'Este pacote só cobre uma visita que inclua todos os seus serviços. Adicione-os ou pague de outra forma.',
          packageExhausted: 'Este pacote não tem agendamentos restantes. Escolha outra forma de pagamento.',
          packageExpired: 'Este pacote expira antes da data do agendamento. Escolha uma data anterior ou pague de outra forma.',
          packageProfessional: 'Este pacote só pode ser marcado com alguns profissionais. Escolha um deles.',
          packageNotUsable: 'Este pacote não pode ser usado neste momento. Escolha outra forma de pagamento.',
          conflict: 'Um agendamento só pode usar uma assinatura ou um pacote.',
        },
      },
      myAppointments: {
        coveredByPackage: 'Coberto pelo pacote',
        packageNote: 'Pacote: {{package}}',
      },
    },
  },
};

export const servicePackageTranslationsEs = {
  membershipPlansManagement: {
    fields: {
      allowanceQuantity: 'Visitas por mes',
    },
  },
  managementAppointments: {
    book: {
      membershipOrPackage: 'Membresía o paquete',
      membershipOrPackageHelp: 'Elige una membresía o un paquete solo cuando esta visita deba usarlo. Un paquete o membresía solo cubre la cita cuando se reservan todos sus servicios.',
      noEntitlementRedemption: 'Pagar normalmente',
      packageTag_one: 'Paquete · {{count}} restante',
      packageTag_other: 'Paquete · {{count}} restantes',
      packageExpiredTag: 'Caducado para esta fecha',
      packageInUseTag: 'En uso',
      packageServicesLocked: 'Los servicios del paquete están seleccionados y no se pueden quitar. Puedes añadir servicios extra.',
    },
  },
  customer: {
    navigation: {
      packages: 'Paquetes',
    },
    memberships: {
      entitlement: {
        allowance: '{{count}} visitas por mes',
      },
      usage: {
        remaining: '{{remaining}} de {{total}} visitas restantes en este período',
      },
    },
    packages: {
      title: 'Paquetes',
      subtitle: 'Paga una vez y reserva tus citas cuando te venga bien.',
      browseOnly: 'Los paquetes se venden en la tienda. Pregunta al equipo en tu próxima visita.',
      inStoreOnlyMessage: 'Disponible en la tienda.',
      card: {
        unnamed: 'Paquete',
        owned: 'Tuyo',
        quantity_one: '{{count}} cita',
        quantity_other: '{{count}} citas',
        expiresInMonths_one: 'Válido durante {{count}} mes',
        expiresInMonths_other: 'Válido durante {{count}} meses',
        noExpiry: 'Sin fecha de caducidad',
        includes: 'Incluye: {{services}}',
      },
      usage: {
        remaining: '{{remaining}} de {{total}} restantes',
        validUntil: 'Válido hasta el {{date}}',
        noExpiry: 'Sin fecha de caducidad',
      },
      actions: {
        buy: 'Comprar paquete',
        bookWithPackage: 'Reservar con el paquete',
        unavailable: 'No disponible online',
      },
      checkout: {
        processing: 'Estamos confirmando tu pago. El paquete aparecerá aquí en cuanto termine.',
        success: 'Pago recibido. Tu paquete está listo para usar.',
      },
      expiryWarning: {
        title: 'Este paquete caduca',
        message_one: 'Este paquete es válido durante {{count}} mes desde la compra, hasta el {{date}}. Las citas no usadas para entonces se pierden y no se reembolsan.',
        message_other: 'Este paquete es válido durante {{count}} meses desde la compra, hasta el {{date}}. Las citas no usadas para entonces se pierden y no se reembolsan.',
        confirm: 'Lo entiendo, continuar',
      },
      empty: {
        title: 'Aún no hay paquetes',
        subtitle: 'Esta tienda no tiene paquetes a la venta ahora mismo.',
      },
      error: {
        loading: 'No se pudieron cargar los paquetes. Inténtalo de nuevo.',
        alreadyActive: 'Ya tienes este paquete. Úsalo por completo antes de volver a comprarlo.',
        unavailable: 'Este paquete ya no está a la venta.',
        onlinePaymentsDisabled: 'Esta tienda cobra tus pagos en la tienda. Pide al equipo que te venda este paquete.',
      },
      profile: {
        title: 'Mis paquetes',
      },
    },
    appointments: {
      booking: {
        yourPackages: 'Tus paquetes',
        discoverPackagesPrompt: '¿Vienes a menudo?',
        seePackages: 'Mira nuestros paquetes',
        packageExtrasHint: 'Los servicios del paquete permanecen seleccionados. Puedes añadir servicios extra de pago.',
        payWithPackage: 'Usar paquete: {{package}} ({{remaining}} restantes)',
        packageSuccess: '¡Cita reservada con tu paquete!',
        entitlementErrors: {
          membershipRequiresAllServices: 'Esta membresía solo cubre una visita que incluya todos sus servicios. Añádelos o paga de otra forma.',
          membershipExceeded: 'Esta membresía no tiene visitas restantes en este período. Elige otra forma de pago.',
          packageRequiresAllServices: 'Este paquete solo cubre una visita que incluya todos sus servicios. Añádelos o paga de otra forma.',
          packageExhausted: 'Este paquete no tiene citas restantes. Elige otra forma de pago.',
          packageExpired: 'Este paquete caduca antes de la fecha de la cita. Elige una fecha anterior o paga de otra forma.',
          packageProfessional: 'Este paquete solo se puede reservar con algunos profesionales. Elige uno de ellos.',
          packageNotUsable: 'Este paquete no se puede usar ahora mismo. Elige otra forma de pago.',
          conflict: 'Una cita solo puede usar una membresía o un paquete.',
        },
      },
      myAppointments: {
        coveredByPackage: 'Cubierto por el paquete',
        packageNote: 'Paquete: {{package}}',
      },
    },
  },
};
